import { Dropdown } from '@fluentui/react';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { ADD_IDGINTEGRATION } from '../../../actions/types'
import InfoTooltip from '../../formFields/InfoTooltip';

const IdgSubSerieDelimiter = ({name}) => {

    const dispatch = useDispatch()
    const idgIntegration = useSelector((state) => state.newSite.idgIntegration)

    const dispatchIdgIntegration = (payload) => {
        dispatch({ type: ADD_IDGINTEGRATION, payload })
    }

    const setSubSerieDelimiter = (e, value) => {
        dispatchIdgIntegration({...idgIntegration, subSerieDelimiter: value.key})
    }

    const containerStyles = {
        marginBottom: 7,
        position: 'relative'
    }

    const controlStyles = {
        position: 'absolute',
        top: '115px',
        width: '100%'
    }

    const dropDownStyles = {
        root: {
            display: 'flex'
        },
        label: {
            flex: 1
        },
        dropdown: {
            flexBasis: '250px'
        }
    }

    const labelTooltip = 
        <div>
            <div>
                <strong>C</strong> - <em>Configurable Product/Container/Price List</em> - Base configurable product or an object that can be used to hold or transport something or a price list identifier
            </div>
            <div>
                <strong>R</strong> - <em>Products</em> - All Products, materials, articles, items, components (incl. HW)
            </div>
            <div>
                <strong>D</strong> - <em>All documents (except below)</em> - Release, Design specs, test plans, projects plan, etc... All documents (except below)
            </div>
            <div>
                <strong>F</strong> - <em>Process documents</em> - Process or function related documents
            </div>
        </div>


    const label = 
        <div>
            IDG SubSerie Delimiter
            <InfoTooltip content={labelTooltip}/>
        </div>

    const subSerieDelimiterContainer =  <div style={containerStyles}>
                                            <Dropdown
                                                label={label}
                                                onChange={setSubSerieDelimiter}
                                                options={idgIntegration.subSerieDelimiters.map(x => ({key: x, text: x}))}
                                                selectedKey={idgIntegration.subSerieDelimiter}
                                                styles={dropDownStyles}
                                            />
                                        </div>

    return(
        <div style={controlStyles}>
            <div>
                {subSerieDelimiterContainer}
            </div>
        </div>
    )
}

export default IdgSubSerieDelimiter


// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/IdgSubSerieDelimiter.js